export enum SheetGeometryGroupId {
  ANNOTATION = "ANNOTATION",
  AUTO_DIMENSION = "AUTO_DIMENSION",
  CALLOUT = "CALLOUT",
  CASEWORK = "CASEWORK",
  CEILING = "CEILING",
  COLUMN = "COLUMN",
  DEBUG = "DEBUG",
  DOORS = "DOORS",
  ELECTRICAL = "ELECTRICAL",
  FLOOR = "FLOOR",
  FLOOR_ANALYTICAL = "FLOOR_ANALYTICAL",
  FOUNDATION_DIMENSIONS = "FOUNDATION_DIMENSIONS",
  FOUNDATION_PARTS = "FOUNDATION_PARTS",
  LEVEL_ANNOTATION = "LEVEL_ANNOTATION",
  MANUAL_DIMENSION = "MANUAL_DIMENSION",
  PERIMETER = "PERIMETER",
  PIER = "PIER",
  PORCH = "PORCH",
  PROPS = "PROPS",
  RAILING = "RAILING",
  ROOF = "ROOF",
  SITE = "SITE",
  ROOF_ANNOTATION = "ROOF_ANNOTATION",
  ROOF_OVERHANG_DIMENSIONS = "ROOF_OVERHANG_DIMENSIONS",
  ROOM = "ROOM",
  SLAB = "SLAB",
  STAIR = "STAIR",
  STEM_WALL = "STEM_WALL",
  TAGS = "TAGS",
  TRIM = "TRIM",
  WAINSCOTING = "WAINSCOTING",
  WALL_EXTERIOR_DIMENSIONS = "WALL_EXTERIOR_DIMENSIONS",
  WALL_INTERIOR_DIMENSIONS = "WALL_INTERIOR_DIMENSIONS",
  WALLS = "WALLS",
  WINDOWS = "WINDOWS",
}

export const sheetGeometryGroupPrettyNames: Record<SheetGeometryGroupId, string> = {
  [SheetGeometryGroupId.ANNOTATION]: "Manual Annotation",
  [SheetGeometryGroupId.AUTO_DIMENSION]: "Dimensions - Auto",
  [SheetGeometryGroupId.CALLOUT]: "Callouts",
  [SheetGeometryGroupId.CEILING]: "Ceiling",
  [SheetGeometryGroupId.COLUMN]: "Columns",
  [SheetGeometryGroupId.DOORS]: "Doors",
  [SheetGeometryGroupId.ELECTRICAL]: "Electrical",
  [SheetGeometryGroupId.FLOOR]: "Floor",
  [SheetGeometryGroupId.FLOOR_ANALYTICAL]: "Floor",
  [SheetGeometryGroupId.FOUNDATION_DIMENSIONS]: "Dimensions - Auto Foundation",
  [SheetGeometryGroupId.FOUNDATION_PARTS]: "Foundation General",
  [SheetGeometryGroupId.LEVEL_ANNOTATION]: "Level Annotations",
  [SheetGeometryGroupId.MANUAL_DIMENSION]: "Dimensions - Manual",
  [SheetGeometryGroupId.PERIMETER]: "Building Perimeter",
  [SheetGeometryGroupId.PIER]: "Foundation Pier",
  [SheetGeometryGroupId.PROPS]: "Props",
  [SheetGeometryGroupId.RAILING]: "Railing",
  [SheetGeometryGroupId.PORCH]: "Porch",
  [SheetGeometryGroupId.WALLS]: "Walls",
  [SheetGeometryGroupId.CASEWORK]: "Casework",
  [SheetGeometryGroupId.WINDOWS]: "Windows",
  [SheetGeometryGroupId.WAINSCOTING]: "Wainscoting",
  [SheetGeometryGroupId.ROOM]: "Room",
  [SheetGeometryGroupId.ROOF]: "Roof",
  [SheetGeometryGroupId.SITE]: "Site",
  [SheetGeometryGroupId.ROOF_ANNOTATION]: "Roof Annotation",
  [SheetGeometryGroupId.ROOF_OVERHANG_DIMENSIONS]: "Dimensions - Auto Roof Overhang",
  [SheetGeometryGroupId.SLAB]: "Foundation Slab",
  [SheetGeometryGroupId.STAIR]: "Stairs",
  [SheetGeometryGroupId.STEM_WALL]: "Foundation Stem Wall",
  [SheetGeometryGroupId.TAGS]: "Tags",
  [SheetGeometryGroupId.TRIM]: "Trim",
  [SheetGeometryGroupId.WALL_EXTERIOR_DIMENSIONS]: "Dimensions - Auto Exterior Wall",
  [SheetGeometryGroupId.WALL_INTERIOR_DIMENSIONS]: "Dimensions - Auto Interior Wall",
  [SheetGeometryGroupId.DEBUG]: "Debug",
};

export function isSheetGeometryGroupId(value: string): value is SheetGeometryGroupId {
  return Object.values(SheetGeometryGroupId).includes(value as SheetGeometryGroupId);
}
